const DESIGN_WIDTH = 375;
const MAX_WIDTH = 430;
const ROOT_VALUE = 37.5;
const DESKTOP_BREAKPOINT = 768;

function getLayoutWidth() {
  return document.documentElement.clientWidth || window.innerWidth || DESIGN_WIDTH;
}

function isDesktopViewport(layoutWidth) {
  if (window.matchMedia) {
    return window.matchMedia('(min-width: 768px) and (hover: hover) and (pointer: fine)').matches;
  }
  return layoutWidth >= DESKTOP_BREAKPOINT;
}

function isAppleMobileDevice() {
  return /iPhone|iPad|iPod/i.test(navigator.userAgent || '')
    || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
}

function getViewportHeight() {
  const innerHeight = Number(window.innerHeight) || 0;
  const visualHeight = Number(window.visualViewport?.height) || 0;

  // iOS needs visualViewport for browser chrome and orientation changes.
  // Android browsers are more consistent with innerHeight, especially when
  // their bottom toolbar expands or collapses.
  if (isAppleMobileDevice()) {
    return visualHeight || innerHeight;
  }
  return innerHeight || visualHeight || document.documentElement.clientHeight;
}

function refreshViewport() {
  const layoutWidth = getLayoutWidth();
  const width = Math.min(layoutWidth, MAX_WIDTH);
  document.documentElement.style.fontSize = `${(width / DESIGN_WIDTH) * ROOT_VALUE}px`;

  // Desktop browsers should use the CSS viewport unit. visualViewport can
  // retain a stale height during Edge route/viewport transitions.
  if (isDesktopViewport(layoutWidth)) {
    document.documentElement.style.removeProperty('--app-viewport-height');
    return;
  }

  const viewportHeight = getViewportHeight();
  if (viewportHeight) {
    document.documentElement.style.setProperty('--app-viewport-height', `${Math.round(viewportHeight)}px`);
  }
}

function preventGestureZoom(event) {
  event.preventDefault();
}

refreshViewport();

window.addEventListener('resize', refreshViewport, { passive: true });
window.addEventListener('orientationchange', refreshViewport, { passive: true });
window.addEventListener('pageshow', refreshViewport, { passive: true });
window.visualViewport?.addEventListener('resize', refreshViewport, { passive: true });

// iOS Safari may ignore user-scalable=no for accessibility gestures.
document.addEventListener('gesturestart', preventGestureZoom, { passive: false });
document.addEventListener('gesturechange', preventGestureZoom, { passive: false });
document.addEventListener('gestureend', preventGestureZoom, { passive: false });
